import { Flex, Heading } from '@chakra-ui/react';

import { StarOutlineIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

import { RPL_EYEBROW } from '../constants';

export function RplStarEyebrow({ color = 'gold.300' }: { color?: string }) {
  return (
    <Flex
      alignItems='center'
      color={color}
      gap={4}
      _after={{
        bgGradient: 'linear(90deg, gold.500 0%, rgba(145, 91, 20, 0) 100%)',
        content: '""',
        display: 'block',
        flex: 1,
        h: '0.5px',
      }}
    >
      <Flex alignItems='center' flexShrink={0} gap={2}>
        <StarOutlineIcon height='16px' width='16px' />
        <Heading
          as='p'
          fontFamily='condensed'
          fontSize='0.9375rem'
          fontWeight='500'
          letterSpacing='0.8px'
          lineHeight='1'
          textTransform='uppercase'
          whiteSpace='nowrap'
        >
          {RPL_EYEBROW}
        </Heading>
      </Flex>
    </Flex>
  );
}
